
var React = require("react");
const {  Link  } = require('react-router-dom');
var LoginUtil = require("../../util/LoginUtil.js");

class AssetDetailsLink extends React.Component  {
    constructor(){
        super()
    }

    render(){
        const { 
            removeDisable = false,
            Content, 
            objUrl,
            mainClass = "",
            style
        } = this.props;

        if(removeDisable) return null;

        if(LoginUtil.isLogin())
            return <Link className={mainClass} style={style} to={objUrl}><Content/></Link>
        else 
            return <div className={mainClass} style={style} onClick={()=>{LoginUtil.goLogin(objUrl.pathname)}}><Content/></div>
       
    }
}

module.exports = AssetDetailsLink;
